<template>
  <div class="col-12 col-sm-6 col-md-4 col-lg-3 col-mlg-3 col-xl-3 d-flex">
    <article
      class="add-page page-block"
      :class="{ colorful: type == 'color' }"
      @click="clickAddPage"
    >
      <div class="outer-round">
        <div class="round">
          <svg
            width="32"
            height="32"
            viewBox="0 0 32 32"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <g>
              <path
                fill-rule="evenodd"
                clip-rule="evenodd"
                d="M0 16C0 15.4477 0.447715 15 1 15H31C31.5523 15 32 15.4477 32 16C32 16.5523 31.5523 17 31 17H1C0.447715 17 0 16.5523 0 16Z"
                fill="currentColor"
              />
              <path
                fill-rule="evenodd"
                clip-rule="evenodd"
                d="M16 0C16.5523 0 17 0.447715 17 1V31C17 31.5523 16.5523 32 16 32C15.4477 32 15 31.5523 15 31V1C15 0.447715 15.4477 0 16 0Z"
                fill="currentColor"
              />
            </g>
          </svg>
        </div>
      </div>
      <p class="typo-button14 typo-medium block-title">{{ $t("page.createNew") }}</p>
    </article>
  </div>
</template>

<script>
export default {
  name: "AddPage",
  props: {
    type: {
      type: String,
      default: ""
    }
  },
  methods: {
    clickAddPage() {
      this.$emit("onClickAddPage");
      this.$emit("click");
    }
  }
};
</script>

<style lang="scss" scoped>
.add-page {
  // border: 1.5px dashed $shade6;
  background: $light1;
  justify-content: center;
  cursor: pointer;
  .block-title {
    text-align: center;
    // margin-bottom: 60px;
    color: $textDarkModeDisabled;
    @include trans-all;
    margin-top: 16px;
  }
  .outer-round {
    display: flex;
    align-self: center;
    .round {
      display: flex;

      svg {
        color: $textDarkModeDisabled;
        @include trans-all;
      }
    }
  }

  &.colorful {
    background: #fff;
    .outer-round {
      border: 1px dashed $cPrimary;

      .round {
        background: $gradientBlue;
        svg {
          color: #fff;
        }
      }
    }
  }

  &:hover {
    .block-title {
      color: $mono3;
    }

    .outer-round .round svg {
      color: $mono3;
    }
  }
}
</style>
